// extracted by mini-css-extract-plugin
export default {"loginForm":"General_loginForm__44jwP"};